import { useTranslation } from 'react-i18next'
import { FeaturesIcon, ModalIcon } from '../components/OnboardingIcons'

export const USER_VIDEO = 'https://www.youtube.com/embed/9u-Z8NuqOKM'

export const useOnboardingData = () => {
  const { t } = useTranslation()

  return {
    tourTipWelcomePoints: [
      { msg: t('usertour.step1.features.item1'), icon: <FeaturesIcon>🎁</FeaturesIcon> },
      { msg: t('usertour.step1.features.item2'), icon: <FeaturesIcon>📊</FeaturesIcon> },
      { msg: t('usertour.step1.features.item3'), icon: <FeaturesIcon>🤝</FeaturesIcon> },
      { msg: t('usertour.step1.features.item4'), icon: <FeaturesIcon>🏆</FeaturesIcon> },
      { msg: t('usertour.step1.features.item5'), icon: <FeaturesIcon>📈</FeaturesIcon> },
    ],
    welcomeIcon: <ModalIcon>🎉</ModalIcon>
  }
}